import styled from 'styled-components';

import { EmailAddress } from '@dreryk/email-address-common-api';

import { ClassNameProp, TextView } from '@dreryk/react-components';

import { practitionersTranslationKeys } from '../../../../translations';

export const StyledEmailTextView = styled(TextView)`
   word-break: break-all;
`;

StyledEmailTextView.displayName = 'StyledEmailTextView';

type EmailTextViewProps = ClassNameProp & {
   readonly value: EmailAddress | undefined;
};

export const EmailTextView = (props: EmailTextViewProps): JSX.Element => {
   return (
      <StyledEmailTextView
         label={practitionersTranslationKeys.modal.email}
         testId={'email'}
         className={props.className}
      >
         {props.value?.asString() ?? '-'}
      </StyledEmailTextView>
   );
};
